export default __webpack_public_path__ + "static/ecofriendly-orchid-f3c089e9e673eae0cd5e13d91fe4878d.jpg";